import registerReduxModal from 'components/common/hoc/registerReduxModal'
import UpdateCancelInstructionsModal from './UpdateCancelInstructionsModal'
import { UPDATE_CANCEL_APPOINTMENT_MODAL_NAME } from './constants'

export default registerReduxModal({
  name: UPDATE_CANCEL_APPOINTMENT_MODAL_NAME
})(UpdateCancelInstructionsModal)
